module.exports = __webpack_public_path__ + "static/media/BH.77d001c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BH.svg
// module id = 204
// module chunks = 0